import React, { Component } from 'react';
import { Grid } from '@mui/material';
import { inject } from 'mobx-react';

@inject('menuStore')
class DisplaySetMenu extends Component {
  render() {
    const { setMenuGroups, menuStore } = this.props;

    return (
      <Grid item container direction="column">
        {setMenuGroups.map(setMenuGroup =>
          setMenuGroup.setMenus.map((setMenu, setMenuIndex) => (
            <Grid
              item
              container
              direction="row"
              gap={1}
              key={setMenuIndex}
              style={{ fontSize: '12px', color: '#9D9B9B' }}
            >
              <Grid item xs>
                {`${setMenuGroup.name} (${setMenu.name})`}
              </Grid>
              <Grid item style={{ width: '92px', textAlign: 'right' }}>
                {setMenu.addPrice > 0 ? `(+${menuStore.numberFormatByLocale(setMenu.addPrice)})` : ''}
              </Grid>
            </Grid>
          )),
        )}
      </Grid>
    );
  }
}

export default DisplaySetMenu;
